import React from 'react';
import { Profile } from '../../components/routes/account/profile';
export const ProfileContainer = ({
  children,
  passwordNotSet
}) => {
  return /*#__PURE__*/React.createElement(Profile, {
    passwordNotSet: passwordNotSet
  }, children);
};